import { Form, Input } from "antd";
import React from "react";
import ColorOptions from "./ColorOptions";

const TextOnly = ({
  titleLable,
  settitleLable,
  bgcolorBadge,
  handleChangeColors,
  handleChangeTxtColor,
  txtcolor,
}) => {
  return (
    <>
      <Form
        name="basic"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: "100%", width: "100%", fontWeight: 600 }}
        autoComplete="off"
        colon={false}
      >
        <Form.Item label="Background Color" >
          <ColorOptions value={bgcolorBadge} onChange={handleChangeColors} />
        </Form.Item>
        <Form.Item label="Title">
          <Input
            defaultValue={titleLable}
            maxLength={25}
            onChange={(e) => settitleLable(e.target.value)}
          />
        </Form.Item>
        <Form.Item label="Title Color">
          <ColorOptions value={txtcolor} onChange={handleChangeTxtColor} />
        </Form.Item>
      </Form>
    </>
  );
};

export default TextOnly;
